import { CxEvent } from '@spartacus/core';

export class Ga4GgCategoryListingFacetSelectEvent extends CxEvent {
  event?: string;
  click_text?: string;
  name?: string;
  visitor_type?: string;
}
